/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Review_Sponsor_TitleInputs */

const en_directory_submit_review_sponsor_title = /** @type {(inputs: Directory_Submit_Review_Sponsor_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sponsor`)
};

const zh_directory_submit_review_sponsor_title = /** @type {(inputs: Directory_Submit_Review_Sponsor_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sponsor`)
};

/**
* | output |
* | --- |
* | "Sponsor" |
*
* @param {Directory_Submit_Review_Sponsor_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_review_sponsor_title = /** @type {((inputs?: Directory_Submit_Review_Sponsor_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Review_Sponsor_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_review_sponsor_title(inputs)
	return zh_directory_submit_review_sponsor_title(inputs)
});
export { directory_submit_review_sponsor_title as "directory.submit.review.sponsor_title" }